import { NavLink } from "react-router-dom";
import { Entity, Page } from "../types";

interface SidebarProps {
  pages: Entity<Page>;
}

const Sidebar: React.FC<SidebarProps> = ({ pages }) => {
  let counter = 1;
  return (
    <div className="sidebar">
      {pages.allIds.map((id) => (
        <div key={id} className="link-container">
          <NavLink activeClassName="active" to={`/${pages.byId[id]?.short}`}>
            {`0${counter++}`}
          </NavLink>
        </div>
      ))}
      <div className="link-container">
        <NavLink activeClassName="active" to="/summary">
          {`0${counter}`}
        </NavLink>
      </div>
    </div>
  );
};

export default Sidebar;
